import * as J from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { getAspectCorrectedCoordinates as Z } from "../../utilities/uv.js";
import { grain as $ } from "../../helpers/grain.js";
import { distort as oo } from "../../helpers/distort.js";
import { glow as to } from "../../helpers/glow.js";
import { edgeMask as so } from "../../helpers/edgeMask.js";
const ao = {
  name: "Chromatic8",
  collection: "chromatic",
  tags: ["wave", "gradient"],
  props: {
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the wave effect."
    }
  },
  fragmentNode: (m) => {
    const {
      vec3: d,
      vec4: E,
      time: O,
      mix: n,
      sin: T,
      float: o,
      pow: c,
      uv: l,
      color: t
    } = J, r = t("#dfbb43"), f = t("#e12c86"), N = t("#e64a9d"), u = t("#999c36"), C = t("#253b81"), S = t("#ff07de"), p = 0.3, I = 2, R = -0.1, D = 0.1, G = 0.15, A = 0.6, L = 56, b = 0.9, g = 0.022, Y = 1, F = 0.5, v = 0.6, w = 0.8, x = 1, U = 0.3, B = 0.01, s = l(), { correctedUV: V } = Z(), _ = oo(s, G, A, L), W = c(r, o(2.2)), h = c(f, o(2.2)), y = c(N, o(2.2)), k = c(u, o(2.2)), H = n(
      W,
      h,
      s.x
    ), P = n(
      k,
      y,
      s.x
    ), K = n(
      H,
      P,
      s.y
    ), a = _.x.sub(0.5), i = _.y.sub(0.5), M = i.mul(a).add(i.mul(a)).negate(), e = o(1).add(
      o(b).mul(
        T(
          M.add(O.mul(m.speed.uniform).mul(0.02)).div(g)
        )
      )
    ), Q = so({
      inset: p,
      softness: I,
      offsetX: R,
      offsetY: D
    }), X = d(e, e, e).mul(Q).mul(Y), z = n(
      S.mul(B),
      C.mul(U),
      s.y.mul(s.x)
    ), j = $(F)(V), q = E(
      z.add(K.mul(X)).sub(j),
      1
    );
    return to(q, r, v, w, x);
  }
};
export {
  ao as componentDefinition,
  ao as default
};
